import * as React from "react";

import { Button } from "@repo/ui/components/button";
import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";

import { AdminSchedulingBoard } from "@/components/scheduling/admin-scheduling-board";

const dateRegex = /^\d{4}-\d{2}-\d{2}$/;

export const Route = createFileRoute("/_authed/staff-photo-shoots/$date")({
  head: () => ({ meta: [{ title: "Staff Photo Shoots" }] }),
  component: StaffPhotoShootsDay,
});

function StaffPhotoShootsDay() {
  const { date } = Route.useParams();
  const navigate = useNavigate({ from: Route.fullPath });

  if (!dateRegex.test(date) || Number.isNaN(new Date(`${date}T00:00:00`).getTime())) {
    return (
      <div className="flex min-h-64 items-center justify-center p-6">
        <div className="max-w-md rounded-lg border p-6">
          <h1 className="text-lg font-semibold">Invalid shoot date</h1>
          <p className="mt-2 text-sm text-muted-foreground">Use the YYYY-MM-DD format.</p>
          <Button className="mt-4" variant="outline" render={<Link to="/staff-photo-shoots" />}>
            Back to Staff Photo Shoots
          </Button>
        </div>
      </div>
    );
  }

  return (
    <React.Fragment>
      <div className="flex h-[calc(100svh-3.5rem)] min-h-0 overflow-hidden p-3">
        <AdminSchedulingBoard
          date={date}
          onDateChange={(nextDate) =>
            navigate({ to: "/staff-photo-shoots/$date", params: { date: nextDate }, replace: true })
          }
        />
      </div>
    </React.Fragment>
  );
}
